export interface NotificationRouteSource {
  type?: string;
  related?: string;
  relatedCode?: string | number;
}

export const NOTIFICATION_FALLBACK_ROUTE = '/directory';

const STATIC_ROUTES: Record<string, string> = {
  newHireApproval: '/directory/approvals/new-hire',
  newHireApprovalChange: '/directory/approvals/new-hire',
  payRateChange: '/directory/approvals/raise',
  timeOffRequest: '/pto/approvals',
  employeeBirthdays: '/directory',
  taskAssigned: '/task-board',
  taskCommentTagged: '/task-board',
  taskCommentCreated: '/task-board',
  approvalCommentCreated: '/directory',
  newMessage: '/messaging',
  welcome: '/home',
};

const getRelatedCode = (source: NotificationRouteSource): string => {
  const code = source?.relatedCode;
  if (code === undefined || code === null) return '';
  const value = String(code).trim();
  return value && value !== '0' ? value : '';
};

export const getNotificationRoute = (source: NotificationRouteSource): string => {
  const type = source?.type || '';

  if (type === 'paperWorkCompleted') {
    const code = getRelatedCode(source);
    return code ? `/users/${code}/profile` : NOTIFICATION_FALLBACK_ROUTE;
  }

  if (type === 'webEnrollmentSubmitted') {
    const code = getRelatedCode(source);
    return code ? `/kids/${code}` : '/home';
  }

  return STATIC_ROUTES[type] || NOTIFICATION_FALLBACK_ROUTE;
};
